import { useCallback, useMemo } from "react";
import { useAuth } from "../contexts/AuthProvider";
import { type CategoricalColor, departmentColor } from "../utils/categoricalColors";
import { compareDepartments } from "../utils/departmentOrder";

/** Colour per department id, by the department's place in the user's list — in the department switcher's order. */
export const useDepartmentColor = (): ((departmentId: string) => CategoricalColor) => {
	const { userInfo } = useAuth();
	const orderedIds = useMemo(() => [...userInfo.departments].sort(compareDepartments).map((dept) => dept.department_id), [userInfo.departments]);
	return useCallback((departmentId: string) => departmentColor(departmentId, orderedIds), [orderedIds]);
};
